import React from 'react';
import moment from 'moment-timezone';
import { Provider } from 'react-redux';
import GlobalStyles from '@iso/assets/styles/globalStyle';
import Refresh from '@iso/assets/styles/refresh';
import { store } from './redux/store';
import Routes from './router';
import AppProvider from './AppProvider';
import SessionGuard from '@iso/components/SessionGuard';

moment.tz.setDefault("Europe/Madrid");

const App = () => (
  <Provider store={store}>
    <AppProvider>
      <>
        <GlobalStyles />
        <Refresh />
        <SessionGuard />
        <Routes />
      </>
    </AppProvider>
  </Provider>
);

export default App;
